export const REJECTION_CODE_CATEGORY = 'Payment ACH'
export const REJECTION_CODE_DIRECTION = 'Debit'

export const REJECTION_CODES: Record<string, string> = {
  R01: 'R01 - Insufficient Funds',
  R02: 'R02 - Account Closed',
  R03: 'R03 - No Account/Unable to Locate Account',
  R04: 'R04 - Invalid Account Number',
  R05: 'R05 - Unauthorised Consumer Debit using Corporate SEC Code Entry',
  R06: "R06 - Returned per ODFI's Request",
  R07: 'R07 - Authorization Revoked by Customer (adjustment entries)',
  R08: 'R08 - Payment Stopped',
  R09: 'R09 - Uncollected Funds',
  R10:
    'R10 - Customer Advises Not Authorized; Item Is Ineligible, Notice Not Provided, Signatures Not Genuine, or Item Altered (adjustment entries)',
  R11: 'R11 - Customer Advises Entry Not Within the Authorization Terms',
  R12: 'R12 - Branch Sold to Another DFI',
  R13: 'R13 - RDFI not qualified to participate',
  R14: 'R14 - Representative Payee Deceased or Unable to Continue in that Capacity',
  R15: 'R15 - Beneficiary or Account Holder Deceased',
  R16: 'R16 - Account Frozen',
  R17: 'R17 - File Record Edit Criteria',
  R20: 'R20 - Non-Transaction Account',
  R21: 'R21 - Invalid Company Identification',
  R22: 'R22 - Invalid Individual ID Number',
  R23: 'R23 - Credit Entry Refused by Receiver',
  R24: 'R24 - Duplicate Entry',
  R27: 'R27 - Trace Number Error',
  R29: 'R29 - Corporate Customer Advises Not Authorized',
  R31: 'R31 - Permissible Return Entry (CCD and CTX only)',
  R33: 'R33 - Return of XCK Entry',
}
